'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    $(document).tooltip({
        items: ".tooltip, .tooltip-href",
        track: true,
        content: function (callback) {
            var element = $( this );
            //using .tooltip when content is static
            if (element.is( ".tooltip" )) {
                return element.find('.tooltip-content').html();
            }
            //using .tooltip-href when content is async
            if (element.is( ".tooltip-href" ), {credentials: "include"}) {
                return fetch(element.attr("href")).then( function(response) {
                    return response.text();
                }).then(function (html) {
                    callback(html)
                    return html;
                })
            }
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};
